/* Ofertas por kit: cada tarjeta = una variante real. Emite "kit-offers:change". */
if (!customElements.get('kit-offers')) {
  customElements.define(
    'kit-offers',
    class KitOffers extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this._priceCache = new Map();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        this.cards = Array.from(this.querySelectorAll('.ko-card'));
        if (!this.cards.length) return;
        this.sectionId = this.dataset.section;
        this.form = document.getElementById(this.dataset.form);
        this.qtyInput = this.ensureQtyInput();
        this.bar = this.querySelector('.ko-bar');
        this.sum = this.querySelector('.ko-sum');

        this.cards.forEach((card) => {
          const radio = card.querySelector('.ko-radio');
          radio.addEventListener('change', () => {
            if (radio.checked) this.select(card, true);
          });
        });

        // Precarga del bloque de precio en cuanto el cliente toca el modulo
        const warm = () => this.prefetchPrices();
        this.addEventListener('pointerdown', warm, { once: true });
        this.addEventListener('focusin', warm, { once: true });

        // Editor de temas: al seleccionar el bloque, lo centra en pantalla
        this._onBlockSelect = (e) => {
          if (e.detail && e.detail.blockId === this.dataset.block) {
            this.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        };
        document.addEventListener('shopify:block:select', this._onBlockSelect);

        // El precio que ya pinto el servidor queda en cache para volver a el sin peticiones
        const priceEl = document.getElementById(`price-${this.sectionId}`);
        const initialInput = (this.closest('product-info') || document).querySelector('.product-variant-id');
        if (priceEl && initialInput) this._priceCache.set(initialInput.value, Promise.resolve(priceEl.innerHTML));

        const urlVariant = new URLSearchParams(window.location.search).get('variant');
        let start = urlVariant ? this.cards.find((c) => c.dataset.variantId === urlVariant) : null;
        if (!start && this.dataset.preselect === 'badge') {
          start = this.cards.find((c) => c.dataset.badge === 'true' && c.dataset.available === 'true');
        }
        if (!start) start = this.cards.find((c) => c.dataset.available === 'true') || this.cards[0];
        this.select(start, false);
      }

      disconnectedCallback() {
        if (this._onBlockSelect) document.removeEventListener('shopify:block:select', this._onBlockSelect);
      }

      ensureQtyInput() {
        // product-form.js y el boton de Shop Pay leen #hiddenQuantityInput: solo puede haber uno
        let input = document.getElementById('hiddenQuantityInput');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          input.id = 'hiddenQuantityInput';
          input.value = '1';
          (this.form || this).appendChild(input);
        }
        return input;
      }

      select(card, userAction) {
        if (!card) return;
        const d = card.dataset;
        const variantId = d.variantId;
        const available = d.available === 'true';
        const previous = this.currentVariant;
        const scope = this.closest('product-info') || document;
        const formInput = scope.querySelector('.product-variant-id');
        const firstRunDiffers = !previous && formInput && formInput.value !== variantId;

        this.cards.forEach((c) => {
          const on = c === card;
          c.classList.toggle('is-active', on);
          c.querySelector('.ko-radio').checked = on;
        });
        if (userAction) {
          card.classList.remove('is-pop');
          void card.offsetWidth;
          card.classList.add('is-pop');
        }
        this.currentVariant = variantId;
        this.qtyInput.value = d.quantity || '1';
        this.dataset.selectedOption = d.index;

        // 1) Variante que va al carrito: formulario, cuotas y barra fija
        document
          .querySelectorAll(`#MainProduct-${this.sectionId} input[name="id"], .sticky-atc-variant-id`)
          .forEach((input) => {
            input.value = variantId;
            input.disabled = false;
          });
        const stickySelect = document.querySelector('.sticky-atc__variant-select');
        if (stickySelect) stickySelect.value = variantId;
        const stickyImg = document.getElementById(`sticky-atc-image-${this.sectionId}`);
        if (stickyImg && d.image) stickyImg.src = d.image;

        // 2) Botones de compra
        scope.querySelectorAll('.product-form__submit, .shopify-payment-button__button').forEach((btn) => {
          if (available) {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
          } else {
            btn.setAttribute('disabled', 'disabled');
          }
        });

        // 3) Barra de envio gratis y resumen (textos calculados en Liquid con datos reales)
        if (this.bar) {
          this.bar.querySelector('.ko-bar__text').textContent = d.barText || '';
          this.bar.style.setProperty('--ko-progress', d.barProgress || '0');
          this.bar.hidden = !d.barText;
        }
        if (this.sum) {
          this.sum.querySelector('.ko-sum__left').textContent = d.name || '';
          this.sum.querySelector('.ko-sum__right').textContent = d.summary || '';
        }

        if (userAction || firstRunDiffers) {
          // 4) URL compartible
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
          // 5) Foto de la variante en la galeria
          if (d.mediaId && this.dataset.gallery !== 'false') {
            const gallery = document.querySelector(`[id^="MediaGallery-${this.sectionId}"]`);
            if (gallery && typeof gallery.setActiveMedia === 'function') {
              gallery.setActiveMedia(`${this.sectionId}-${d.mediaId}`, true);
            }
          }
        }

        // 6) Bloque de precio de arriba
        if ((previous && previous !== variantId) || firstRunDiffers) this.refreshPrice(variantId);

        this.dispatchEvent(
          new CustomEvent('kit-offers:change', {
            bubbles: true,
            detail: {
              variantId: Number(variantId),
              quantity: Number(d.quantity || 1),
              option: Number(d.index),
              name: d.name,
              price: Number(d.price),
              userAction: !!userAction,
            },
          })
        );
      }

      priceUrl(variantId) {
        return `${this.dataset.url}?variant=${variantId}&section_id=${this.sectionId}`;
      }

      fetchPrice(variantId) {
        if (!this._priceCache.has(variantId)) {
          const p = fetch(this.priceUrl(variantId))
            .then((r) => r.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.getElementById(`price-${this.sectionId}`);
              return fresh ? fresh.innerHTML : null;
            })
            .catch(() => {
              this._priceCache.delete(variantId);
              return null;
            });
          this._priceCache.set(variantId, p);
        }
        return this._priceCache.get(variantId);
      }

      prefetchPrices() {
        if (!document.getElementById(`price-${this.sectionId}`)) return;
        this.cards.forEach((c) => {
          if (c.dataset.variantId !== this.currentVariant) this.fetchPrice(c.dataset.variantId);
        });
      }

      refreshPrice(variantId) {
        const priceEl = document.getElementById(`price-${this.sectionId}`);
        if (!priceEl || !this.dataset.url) return;
        this.fetchPrice(variantId).then((html) => {
          if (html === null || this.currentVariant !== variantId) return;
          priceEl.innerHTML = html;
          if (this.dataset.motion === 'true') {
            priceEl.classList.remove('ko-price-in');
            void priceEl.offsetWidth;
            priceEl.classList.add('ko-price-in');
          }
        });
      }
    }
  );
}